import { iAppState, tDiscountPercent } from "../../interfaces/interfaces"
import { availableFTokens, availableUTokens, discountPercents } from "../../settings";
import { eAppActionTypes, tAppAction } from "./appTypes"

const initialState: iAppState = {
	discountPercent: discountPercents[0],
	// currentFToken: null,
	currentFToken: availableFTokens[0],
	// currentUToken: null,
	currentUToken: availableUTokens[0],
	strategy: 0,
	userAddress: null,
	apiData: discountPercents.reduce((accum, val) => ({...accum, [val as tDiscountPercent]: null}), {}) as {[key in tDiscountPercent]: null},
	// appContracts: Object.fromEntries(availableCurrencies.map(currency => [currency, undefined])) as {[key in tAvailableCurrencies]: undefined},
	appContracts: discountPercents.reduce((accum, val) => ({...accum, [val as tDiscountPercent]: null}), {}) as {[key in tDiscountPercent]: null},
	fTokens: discountPercents.reduce((accum, val) => ({...accum, [val as tDiscountPercent]: null}), {}) as {[key in tDiscountPercent]: null},
	uTokens: discountPercents.reduce((accum, val) => ({...accum, [val as tDiscountPercent]: null}), {}) as {[key in tDiscountPercent]: null},
	currentPeriods: discountPercents.reduce((accum, val) => ({...accum, [val as tDiscountPercent]: null}), {}) as {[key in tDiscountPercent]: null},
	currentTimes: discountPercents.reduce((accum, val) => ({...accum, [val as tDiscountPercent]: null}), {}) as {[key in tDiscountPercent]: null},
	deposits: discountPercents.reduce((accum, val) => ({...accum, [val as tDiscountPercent]: []}), {}) as {[key in tDiscountPercent]: []},
	isInited: false,
	// minDeposits: Object.fromEntries(discountPercents.map(percent => [percent, {ft: null, ut: null}])) as {[key in tDiscountPercent]: {ft: null, ut: null}},
	kasAccessToken: null,
}

export const appReducer = (state = initialState, action: tAppAction): iAppState => {
	switch(action.type){
		case eAppActionTypes.CLEAR_STATE:
			return {
				...initialState,
				discountPercent: state.discountPercent,
				// apiData - ?
			}
		;

		case eAppActionTypes.SET_DISCOUNT_PERCENT:
			return {...state, discountPercent: action.payload}
		;

		case eAppActionTypes.SET_CURRENT_F_TOKEN:
			return {...state, currentFToken: action.payload}
		;

		case eAppActionTypes.SET_CURRENT_U_TOKEN:
			return {...state, currentUToken: action.payload}
		;

		case eAppActionTypes.SET_STRATEGY:
			return {...state, strategy: action.payload}
		;

		case eAppActionTypes.SET_USER_ADDRESS:
			return {...state, userAddress: action.payload}
		;

		case eAppActionTypes.SET_API_DATA:
			return {
				...state,
				apiData: Object.assign(
					{},
					state.apiData,
					{[action.payload.percent]: {
						api: action.payload.api,
						config: action.payload.config
					}}
				)
			}
		;

		case eAppActionTypes.SET_IS_INITED:
			return {...state, isInited: action.payload}
		;

		case eAppActionTypes.SET_APP_CONTRACT:
			return {
				...state,
				appContracts: Object.assign(
					{},
					state.appContracts,
					{[action.payload.percent]: action.payload.contract}
				)
			}
		;

		case eAppActionTypes.SET_F_TOKEN:
			return {
				...state,
				fTokens: Object.assign(
					{},
					state.fTokens,
					{[action.payload.percent]: action.payload.token}
				)
			}
		;

		case eAppActionTypes.SET_U_TOKEN:
			return {
				...state,
				uTokens: Object.assign(
					{},
					state.uTokens,
					{[action.payload.percent]: action.payload.token}
				)
			}
		;

		case eAppActionTypes.SET_CURRENT_PERIOD:
			return {
				...state,
				currentPeriods: Object.assign(
					{},
					state.currentPeriods,
					{[action.payload.percent]: action.payload.period}
				)
			}
		;

		case eAppActionTypes.SET_CURRENT_TIME:
			return {
				...state,
				currentTimes: Object.assign(
					{},
					state.currentTimes,
					{[action.payload.percent]: action.payload.time}
				)
			}
		;

		case eAppActionTypes.SET_DEPOSITS:
			return {
				...state,
				deposits: Object.assign(
					{},
					state.deposits,
					{[action.payload.percent]: action.payload.deposits}
				)
			}
		;

		/* case eAppActionTypes.SET_MIN_DEPOSIT:
			return {
				...state,
				minDeposits: Object.assign(
					{},
					state.minDeposits,
					{[action.payload.percent]: action.payload.amounts}
				)
			}
		; */

		case eAppActionTypes.SET_KAS_ACCESS_TOKEN:
			return {
				...state,
				kasAccessToken: action.payload
			}
		;

		default: return state;
	}
}